export default "__VITE_ASSET__bbf02a61__"